import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import type { IWikifolioFeedDict } from "src/api/server/wf-detail.types";
import { EmptyState } from "src/components/common/empty-state";
import type { IFeedCard } from "src/components/feed-card/types/feed-card";
import { FeedLoadingState } from "./feed-loading-state";

export interface IFeedStateRendererProps {
    feed: IFeedCard[] | null;
    isLoading: boolean;
    isError: boolean;
    dict: IWikifolioFeedDict;
    children: React.ReactNode;
}

export const FeedStateRenderer = ({ feed, isLoading, isError, dict, children }: IFeedStateRendererProps) => {
    const { t } = useTranslation("common");

    const showError = !feed && isError;
    const showLoading = (!feed || isLoading) && !isError;
    const showEmpty = feed && !feed.length;
    const showContent = feed && feed.length > 0;

    return (
        <Box sx={{ display: "flex", flexFlow: "column", gap: 2 }}>
            {showError && <EmptyState title={t("errors.messages.generic.heading")} description={t("errors.messages.generic.message")} />}
            {showLoading && <FeedLoadingState />}
            {showEmpty && <EmptyState {...dict.empty} />}
            {showContent && children}
        </Box>
    );
};
